import { Component } from "@angular/core";
import { faCheckCircle, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { Account } from "src/app/models/Account";
import { Brand } from "src/app/models/Brand";
import { BrandingService } from "src/app/services/branding.service";
import { PendingUserService } from "src/app/services/pending-user.service";

import { CompanyService } from "./../../services/company.service";

@Component({
  selector: "app-request-account",
  templateUrl: "./request-account.component.html",
  styleUrls: ["./request-account.component.scss"],
  standalone: false,
})
export class RequestAccountComponent {
  countries$: Observable<Brand[]>;
  account: Account;
  referenceId: string;
  faSpinner = faSpinner;
  faCheckCircle = faCheckCircle;
  isLoading: boolean;
  userAlreadyExists: boolean;

  constructor(
    private companyService: CompanyService,
    private pendingUserService: PendingUserService,
    private brandingService: BrandingService,
  ) {
    this.countries$ = this.companyService.getCountriesByBrand(this.brandingService.currentBrand);
    this.account = new Account();
  }

  submit() {
    if (!this.userAlreadyExists) {
      this.isLoading = true;

      this.pendingUserService
        .requestAccount(this.account)
        .pipe(finalize(() => (this.isLoading = false)))
        .subscribe((result) => {
          this.referenceId = result;
        });
    }
  }

  onCountryChange(c) {
    this.account.country = c.country;
    this.account.brand = c.brand;
    this.account.fam = c.fam;
    this.validateEmail();
  }

  validateEmail() {
    // TODO: Implement angular custom validator on email field
    if (this.account.email && this.account.fam) {
      this.isLoading = true;
      this.pendingUserService
        .userExists({ email: this.account.email, fam: this.account.fam })
        .pipe(finalize(() => (this.isLoading = false)))
        .subscribe((response) => (this.userAlreadyExists = response));
    }
  }
}
